import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useEffect, useMemo } from 'react';
import PropTypes from "prop-types";
import Spinner from "../../common/spinners/Spinner";
import "../../InsuranceInformation/stylesheets/PaymentsInsuranceFields.scss";
import "../stylesheets/SocialInsuranceFields.scss";
import { useFindFeeScheduleInsurances, useFindSocialInsurances } from '../hooks';
import { hooks } from '../../../config/api';
import { INSURANCE_STATUSES } from './constants';
var ExistingInsurancePlans = function ExistingInsurancePlans(_ref) {
  var _selectedPlan$fee_sch2, _feeSchedulesResponse, _feeSchedulesResponse2;
  var selectedPlan = _ref.selectedPlan,
    setDisableEnrollment = _ref.setDisableEnrollment,
    contactId = _ref.contactId;
  var setInsuranceState = function setInsuranceState(insurance) {
    return insurance.insurance_status === INSURANCE_STATUSES.pending_disenrollment ? 'active' : insurance.state;
  };
  var findExistingPlanInsurance = function findExistingPlanInsurance() {
    var insurances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var selectedPlan = arguments.length > 1 ? arguments[1] : undefined;
    return _findInstanceProperty(insurances).call(insurances, function (insurance) {
      return insurance.plan.id === selectedPlan.id;
    });
  };
  var findExistingFeeScheduleEnrollment = function findExistingFeeScheduleEnrollment(insurances, selectedPlan) {
    if (selectedPlan.enrollment_required) {
      var _loop = function _loop() {
          var _insurances$i$plan$fe, _selectedPlan$fee_sch;
          var feeScheduleIds = (_insurances$i$plan$fe = insurances[i].plan.fee_schedules) === null || _insurances$i$plan$fe === void 0 ? void 0 : _mapInstanceProperty(_insurances$i$plan$fe).call(_insurances$i$plan$fe, function (feeSchedule) {
            return feeSchedule.id;
          });
          var feeSchedule = (_selectedPlan$fee_sch = selectedPlan.fee_schedules) === null || _selectedPlan$fee_sch === void 0 ? void 0 : _findInstanceProperty(_selectedPlan$fee_sch).call(_selectedPlan$fee_sch, function (feeSchedule) {
            return (feeScheduleIds === null || feeScheduleIds === void 0 ? void 0 : _includesInstanceProperty(feeScheduleIds).call(feeScheduleIds, feeSchedule.id)) && !feeSchedule.allow_multiple_enrollments;
          });
          if (feeSchedule) {
            return {
              v: {
                insuranceState: setInsuranceState(insurances[i]),
                feeScheduleName: feeSchedule.name
              }
            };
          }
        },
        _ret;
      for (var i = 0; i < insurances.length; i++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
    }
    return {
      insuranceState: undefined,
      feeScheduleName: undefined
    };
  };
  var _hooks$useFind = hooks.useFind('fee_schedules', {
      id: (_selectedPlan$fee_sch2 = selectedPlan.fee_schedules) === null || _selectedPlan$fee_sch2 === void 0 ? void 0 : _mapInstanceProperty(_selectedPlan$fee_sch2).call(_selectedPlan$fee_sch2, function (feeSchedule) {
        return feeSchedule.id;
      }).join(',')
    }, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    feeSchedulesResponse = _hooks$useFind.data,
    isFeeSchedulesLoading = _hooks$useFind.isLoading;
  var _useFindSocialInsuran = useFindSocialInsurances(contactId, 'active,pending'),
    socialInsurances = _useFindSocialInsuran.socialInsurances,
    isSocialInsurancesLoading = _useFindSocialInsuran.isLoading;
  var existingPlanInsurance = findExistingPlanInsurance(socialInsurances, selectedPlan);
  var existingPlanInsuranceState = existingPlanInsurance ? setInsuranceState(existingPlanInsurance) : undefined;
  var _useFindFeeScheduleIn = useFindFeeScheduleInsurances(contactId, selectedPlan),
    clientInsurances = _useFindFeeScheduleIn.clientInsurances,
    isClientInsurancesLoading = _useFindFeeScheduleIn.isLoading;
  var _findExistingFeeSched = findExistingFeeScheduleEnrollment(_filterInstanceProperty(clientInsurances).call(clientInsurances, function (insurance) {
      return insurance.plan.enrollment_required === true;
    }), _objectSpread(_objectSpread({}, selectedPlan), {}, {
      fee_schedules: (_feeSchedulesResponse = feeSchedulesResponse === null || feeSchedulesResponse === void 0 || (_feeSchedulesResponse2 = feeSchedulesResponse.data) === null || _feeSchedulesResponse2 === void 0 ? void 0 : _feeSchedulesResponse2.data) !== null && _feeSchedulesResponse !== void 0 ? _feeSchedulesResponse : []
    })),
    feeScheduleInsuranceState = _findExistingFeeSched.insuranceState,
    feeScheduleName = _findExistingFeeSched.feeScheduleName;
  useEffect(function () {
    if (existingPlanInsuranceState || feeScheduleInsuranceState) {
      setDisableEnrollment(true);
    } else {
      setDisableEnrollment(false);
    }
  }, [existingPlanInsurance, feeScheduleInsuranceState, socialInsurances]);
  var messages = {
    pending: {
      plan: "There is already a pending enrollment request for this social care coverage plan.",
      feeSchedule: /*#__PURE__*/React.createElement(React.Fragment, null, "There is a pending enrollment request for a social care coverage for\xA0", /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-red"
      }, feeScheduleName), ". The client cannot be enrolled in another social care coverage under the same contract.")
    },
    active: {
      plan: "The client is already enrolled in this social care coverage plan.",
      feeSchedule: /*#__PURE__*/React.createElement(React.Fragment, null, "The client is already enrolled in a social care coverage for\xA0", /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-red"
      }, feeScheduleName), " and cannot be enrolled in another social care coverage under the same contract.")
    }
  };
  if (isSocialInsurancesLoading || isFeeSchedulesLoading || isClientInsurancesLoading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      scale: 0.5
    });
  } else if (existingPlanInsuranceState) {
    return /*#__PURE__*/React.createElement("p", {
      className: "pb-2 text-red"
    }, messages[existingPlanInsuranceState].plan);
  } else if (feeScheduleInsuranceState) {
    return /*#__PURE__*/React.createElement("p", {
      className: "pb-2 text-red"
    }, messages[feeScheduleInsuranceState].feeSchedule);
  }
  return null;
};
ExistingInsurancePlans.propTypes = {
  selectedPlan: PropTypes.object.isRequired,
  setDisableEnrollment: PropTypes.func.isRequired,
  contactId: PropTypes.string.isRequired
};
export default ExistingInsurancePlans;
//# sourceMappingURL=ExistingInsurancePlans.js.map